export default __webpack_public_path__ + "static/media/returns.38dd058c.svg";